<template>
  <div class="resetPassword xi">
    <nh-com></nh-com>
    <div class="startBox">
      <div class="startBoxCenter">
        <div class="" style="display: flex;justify-content: space-between;align-items: center;">
          <div class="banner-wrap">
            <div class=" " style="color: #666666; font-size: 16px">测试记录</div>
          </div>
          <div style="color: #E07712;cursor: pointer;" @click="goback"><img src="../../assets/img/queImg/pcdx_back.png" alt="" style="margin-right: 5px;" srcset="" >返回上一步</div>
        </div>
        <div style="display: flex;align-items: center;justify-content: space-between;" >
          <div @click="addUserDetail(1)" :class="activeIndex == 1 ? 'activeCheck' : ''" style="width: 350px;height: 100px;background: linear-gradient(180deg, #FAF2ED, #FFFFFF);margin-top: 19px;text-align: center;line-height: 100px;display: flex;align-items: center;justify-content: space-between;padding: 0 20px;cursor: pointer;">
            <div class="flex-start">
              <img src="../../assets/img/queImg/pcdx_ywc.png" style="width: 34px;height: 30px;" alt="" srcset="">
              <span style="font-weight: bold;font-size: 18px;color: #333333;margin-left: 10px;">已完成测试列表</span>
            </div>
          </div>
          <div @click="goAnswerStaging(2)" :class="activeIndex == 2 ? 'activeCheck' : ''"  style="width: 350px;height: 100px;background: linear-gradient(180deg, #FAF2ED, #FFFFFF);margin-top: 19px;text-align: center;line-height: 100px;display: flex;align-items: center;justify-content: space-between;padding: 0 20px;cursor: pointer;">
            <div class="flex-start" >
              <img src="../../assets/img/queImg/pcdxwwc.png" style="width: 34px;height: 30px;" alt="" srcset="">
              <span style="font-weight: bold;font-size: 18px;color: #333333;margin-left: 10px;">未完成测试列表</span>
            </div>
            <span v-if="AnswerStagingList.length > 0" style="font-weight: bold;font-size: 18px;color: #333333;">({{ AnswerStagingList.length }})</span>
          </div>
        </div>
        <template>
          <div class="" style="width: 100%;margin-top: 20px;" v-if="activeIndex == 2">
            <div class="selectUser-div1" style="position: relative;">
              <div class="selectUser-box">
                  <div class="item-div1" v-for="(item, index) in AnswerStagingList" :key="index">
                    <div class="flex-s-b">
                      <div class="" style="display: flex; align-items: center">
                        <div style="margin-right: 10px" class="userNameBox">{{ item.answerUserInfo.answerUserName }}</div>
                        <div class="userInfo">{{ item.answerUserInfo.answerSex ? "女" : "男" }}<span style="margin: 0 10px;">{{ item.answerUserInfo.ageContent }}</span>{{ item.answerUserInfo.showanswerPhone }}</div>
                      </div>
                      <div class="titleBoxTextimage" @click.stop="goChooseCheck(item)">
                        <img :src="item.checked ? urlCheckM : noUrlCheckM" />
                      </div>
                    </div>
                    <div class="flex-s-b" style="margin-top: 15px;">
                      <div class="flex-s-b-r">
                        <div class="" style="display: flex; align-items: center">
                          <div class="userNameBox1" style="color: #DA7F1D"><span style="margin-right: 10px;">答题进度</span>{{ item.questionIndex }}</div>
                          <div class="userNameBox1">{{ "/" + item.questionTotal }}题</div>
                          <div class="userInfo"  style="margin-left: 60px;font-size: 14px;">{{ item.answerDate | timefilters }}</div>
                        </div>
                        <el-progress :percentage="item.percentnum" color="#F7B670"></el-progress>
                      </div>
                      <div style="display: flex; align-items: center">
                        <div class="delBox1" @click.stop="godelBox(item)">
                          删除
                        </div>
                        <div class="delBox" @click.stop="gostartBox(item)">继续测试 ></div>
                      </div>
                    </div>
                  </div>
                <div v-if="AnswerStagingList.length == 0" style="display: flex;align-items: center;flex-direction: column;margin: auto; margin-top: 100px;">
                  <img src="../../assets/img/queImg/nodata1.png" style="width: 217px;height: 120px;"  alt="" srcset="">
                  <span style="text-align: center;margin-top: 10px;">— 暂无数据 —</span>
                </div>
              </div>
              <div class="zsureBtn flex-s-b" v-if="AnswerStagingList.length != 0">
                <div style="display: flex; align-items: center" @click="allSelect">
                    <div class="titleBoxTextimage" style="margin-right: 10px;">
                      <img :src="cssbtn ? urlCheckM : noUrlCheckM" />
                    </div>
                    <span>全选</span>
                  </div>
                  <div class="delBox" @click.stop="goalldelBox" style="margin-left: 40px">删除</div>
                </div>
              </div> 

          </div>
        </template>
        <div class="" style="width: 100%;margin-top: 20px;" v-if="activeIndex == 1">
            <div v-if="activeIndex == 1" class="selectUser-div1">
              <div class="selectUser-box">
                <div style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 20px;">
                  <span style="font-weight: 400;font-size: 20px;color: #333333;">已完成测试列表</span>
                    <div class="flex-end">
                      <el-input placeholder="请输入内容" style="width: 400px" v-model="keyWord" class="input-with-select" @keyup.enter.native="search" clearable>
                        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
                      </el-input>
                    </div>
                </div>
                <div class="drugBox" v-for="(itemDrug, indexDrug) in tableData" :key="indexDrug">
                  <div class="drugBoxtopBox">
                    <div class="drugBoxtop">
                      <div class="ring1"></div>
                      <div style="margin-left: 5px">{{ itemDrug.userName }}</div>
                      <div style="margin-left: 10px">
                        {{ itemDrug.gender ? "女" : "男" }}
                      </div>
                      <div style="margin-left: 15px">
                        {{ itemDrug.ageName }}
                      </div>
                      <div style="margin-left: 10px">
                        {{ itemDrug.userPhone ? itemDrug.userPhone.substr(0, 3) + "****" + itemDrug.userPhone.substr(7) : "" }}
                      </div>
                      <div style="font-size: 14px; margin-top: 0px; margin-left: 30px">
                        <p>您的基础病：{{ itemDrug.answerDiseaseName ? itemDrug.answerDiseaseName : "--" }}</p>
                      </div>
                      <!-- <div style="font-size: 16px; margin-left: 15px">
                      您选择的主症是：<span style="color: #333">{{ itemDrug.primarySymptomName }}</span>
                    </div> -->
                    </div>
                    <div style="font-size: 14px; color: #333; cursor: pointer" @click="goresultB(itemDrug)">查看详情<i class="el-icon-arrow-right"></i></div>
                  </div>
                  <div class="flex-space-between" style="font-size: 14px; margin-top: 5px; width: 100%">
                    <div class="oneLines" style="width: calc(100% - 180px)">
                      <span>您选择的疾病是：{{ itemDrug.primarySymptomName }}</span>
                      <span style="margin-left: 20px">您的症状清单：</span>
                      <span v-for="(itemsym, indexsym) in itemDrug.symptoms" :key="indexsym">
                        {{ "【" + itemsym + "】" }}
                      </span>
                    </div>
                    <div style="width: 140px; text-align: right">{{ itemDrug.diagnosisTime | timefilters }}</div>
                  </div>
              </div>
                <div v-if="tableData.length == 0" style="display: flex;align-items: center;flex-direction: column;margin: auto; margin-top: 100px;">
                  <img src="../../assets/img/queImg/nodata1.png" style="width: 217px;height: 120px;"  alt="" srcset="">
                  <span style="text-align: center;margin-top: 10px;">— 暂无数据 —</span>
                </div>
              <div class="flex-center" style="width: 100%" v-if="tableData.length > 0">
                <el-pagination background layout="total,prev, pager, next" :page-size="15" @current-change="ChangePage2" :current-page.sync="PageIndex" :total="Total"> </el-pagination>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
    <ft-com></ft-com>
  </div>
</template>
<script>
import ftCom from "../../components/footerNew";
import nhCom from "../../components/header";
import { zdrugconsultationMain } from "../../components/zdrugconsultation/zdrugconsultation";
import { Test } from "../../components/company/test";
export default {
  name: "resetPassword",
  components: {
    ftCom,
    nhCom,
  },
  data() {
    var zdrugconsultation = new zdrugconsultationMain(this.TokenClient, this.Services.Disease);
    var test = new Test(this.TokenClient, this.Services.Statics);
    return {
      testDomain: test,
      zdrugconsultationMain: zdrugconsultation,
      http: "",
      pageIndex1: 1,
      pageCount1: 1,
      userInfo: this.$store.state.localData.userInfo,
      selectAnswerUser: "", //测试对象
      keyWord: "",
      AnswerStagingList: [],
      cssbtn:false,
      activeIndex:1,
      tableData:[],
      PageIndex:1,
      PageTotal:1,
      Total:0
    };
  },
  mounted() {
    this.getTCUserSelfDiagnosisRecordList()
    this.getAnswerStagingInfoData()
    this.http = this.Services.ossUpload;
  },
  methods: {
    goresultB(e) {
      this.$router.push({
        path: "/diseaseConsultation/diseaseDetail",
        query: {
          id: e.id,
        },
      });
    },
    ChangePage2(pageIndex) {
      this.PageIndex = pageIndex;
        this.getTCUserSelfDiagnosisRecordList();
    },
    search() {
      this.PageIndex = 1;
      this.tableData = [];
      this.getTCUserSelfDiagnosisRecordList();
    },
    getTCUserSelfDiagnosisRecordList() {
      var _this = this;
      let keyWord = _this.keyWord ?  _this.keyWord : '';
      _this.zdrugconsultationMain.getUserTCMDiseaseRecord(
        "",
        "",
        keyWord,
        _this.PageIndex,
        function (data) {
          _this.PageIndex = data.data.pageIndex;
          _this.PageTotal = data.data.pageCount;
          _this.Total = data.data.dataTotal;
          for (let i = 0; i < data.data.results.length; i++) {
            if (data.data.results[i].age == 0) {
              data.data.results[i].ageName = "6岁以下";
            } else if (data.data.results[i].age == 7) {
              data.data.results[i].ageName = "7-12岁";
            } else if (data.data.results[i].age == 13) {
              data.data.results[i].ageName = "13-17岁";
            } else if (data.data.results[i].age == 18) {
              data.data.results[i].ageName = "18-45岁";
            } else if (data.data.results[i].age == 46) {
              data.data.results[i].ageName = "46-69岁";
            } else if (data.data.results[i].age == -1) {
              data.data.results[i].ageName = data.data.results[i].primarySymptomMinAge + "-" + data.data.results[i].primarySymptomMaxAge + "岁";
            } else {
              data.data.results[i].ageName = "69岁以上";
            }
            // data.data.results[i].diagnosisTime = data.data.results[i].diagnosisTime.slice(0, 10);
          }
          _this.tableData = data.data.results;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    goalldelBox() {
      let params = [];
      for (var i = 0; i < this.AnswerStagingList.length; i++) {
        if (this.AnswerStagingList[i].checked) {
          params.push(this.AnswerStagingList[i].id);
        }
      }
      this.$confirm("确认删除所选记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.testDomain.deleteAnswerStaging(
            params.toString(),
            res => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getAnswerStagingInfoData();
            },
            error => {
              console.log("请求失败!请刷新重试:", error);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    gostartBox(item) {
      this.$router.push({
        path: "/diseaseConsultation/diseaseProgress",
        query: {
          id: this.selfId,
          selectAnswerUser: this.selectAnswerUser,
          age: this.selfAge,
          sex: this.selfSex,
          name: this.quename,
          isgoId: item.id,
        },
      });
    },
    godelBox(e) {
      this.$confirm("确认删除所选记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.testDomain.deleteAnswerStaging(
            e.id,
            res => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getAnswerStagingInfoData();
            },
            error => {
              console.log("请求失败!请刷新重试:", error);
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    allSelect() {
      this.cssbtn = !this.cssbtn;
      if (this.cssbtn == true) {
        for (var i = 0; i < this.AnswerStagingList.length; i++) {
          this.AnswerStagingList[i]["checked"] = true;
        }
      } else {
        for (var i = 0; i < this.AnswerStagingList.length; i++) {
          this.AnswerStagingList[i]["checked"] = false;
        }
      }
    },
    goChooseCheck(e) {
      for (let j = 0; j < this.AnswerStagingList.length; j++) {
        if (e.id == this.AnswerStagingList[j].id) {
          this.AnswerStagingList[j].checked = !this.AnswerStagingList[j].checked;
          // this.$set(this.AnswerStagingList[j], 'checked' , !this.AnswerStagingList[j].checked, )
        }
      }
      const allcartList = this.AnswerStagingList.every(item => {
        return item.checked == true;
      });
      if (allcartList) {
        this.cssbtn = true;
      } else {
        this.cssbtn = false;
      }
    },
    goback(){
      this.$router.go(-1)
    },
    goback1(){
      this.addUser = 1
    },
    addUserDetail() {
      this.keyWord = ""
      this.activeIndex = 1
      this.getTCUserSelfDiagnosisRecordList()
    },
    goAnswerStaging() {
      this.activeIndex = 2
      this.getAnswerStagingInfoData();
    },
    getAnswerStagingInfoData() {
      this.testDomain.getAnswerStaging(
        "z1",
        res => {
          this.AnswerStagingList = res.data;
          for (let i = 0; i < this.AnswerStagingList.length; i++) {
            this.AnswerStagingList[i].answerUserInfo.showanswerPhone = this.AnswerStagingList[i].answerUserInfo.answerPhone.substr(0, 3) + "****" + this.AnswerStagingList[i].answerUserInfo.answerPhone.substr(7);
            if (this.AnswerStagingList[i].answerUserInfo.answerAge == 0) {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "6岁以下";
            } else if (this.AnswerStagingList[i].answerUserInfo.answerAge == 1) {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "7-12岁";
            } else if (this.AnswerStagingList[i].answerUserInfo.answerAge == 2) {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "13-17岁";
            } else if (this.AnswerStagingList[i].answerUserInfo.answerAge == 3) {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "18-45岁";
            } else if (this.AnswerStagingList[i].answerUserInfo.answerAge == 4) {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "46-69岁";
            } else {
              this.AnswerStagingList[i].answerUserInfo["ageContent"] = "69岁以上";
            }
            this.AnswerStagingList[i]["percentnum"] = (100 / this.AnswerStagingList[i].questionTotal) * this.AnswerStagingList[i].questionIndex;
            // this.AnswerStagingList[i]['checked'] = false
            this.$set(this.AnswerStagingList[i], "checked", false);
          }
        },
        error => {
          this.AnswerStagingList = [];
        }
      );
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/footer.css";
::v-deep .el-progress__text {
  display: none;
}
.activeCheck {
  border: 1px solid #FFCDB2;
}

.titleBoxTextimage {
  width: 14px;
  height: 14px;
}
.titleBoxTextimage img {
  width: 100%;
  height: 100%;
  display:block;
}
.flex-s-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex-s-b-r {
  display: flex;
  flex-direction: column;
  width: 60%;
}
.delBox1 {
  width: 80px;
  /* height: 30px; */
  font-size: 14px;
  background: rgba(255,255,255,0);
  border-radius: 4px;
  border: 1px solid #CCCCCC;
  font-size: 14px;
  color: #666666;
  text-align: center;
  padding: 5px 0;
}
.delBox {
  width: 100px;
  /* height: 30px; */
  font-size: 14px;
  color: #ffffff;
  background: linear-gradient(270deg, #EEAB66, #EFC279);
  border-radius: 4px;
  text-align: center;
  padding: 5px 0;
  margin-left: 10px;
}
.userNameBox1 {
  font-size: 14px;
  color: #666666;
}
.userNameBox {
  max-width: 120px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*不换行*/
  text-overflow: ellipsis; /*超出部分文字以...显示*/
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  color: #333333;
}
.banner-wrap {
  /* position: relative;
  height: 100%;
  margin: 0 auto; */
}
.leftbox {
  display: flex;
  align-items: center;
}
.leftMessage {
  max-width: 240px;
  margin-top: 15px;
  font-size: 14px;
  padding: 15px;
  background-color: #f4f4f4;
  border-radius: 0px 15px 15px 15px;
  margin-left: 10px;
}
.resultMessage {
  width: 100%;
  margin-top: 15px;
  padding: 15px;
  margin-left: 10px;
  border: 1px solid #f2f2f2;
  box-shadow: 0px 5px 10px 0px rgba(153, 153, 153, 0.16);
  border-radius: 16px;
}
.rightbox {
  display: flex;
  justify-content: flex-end;
  text-align: right;
}
.rightMessage {
  max-width: 240px;
  margin-top: 15px;
  font-size: 14px;
  padding: 15px;
  background-color: #ee9e51;
  border-radius: 15px 0px 15px 15px;
  color: #fff;
}
.startBox {
  background: linear-gradient(180deg, #FFEFDE 0%, #F5F5F5 50%);
  /* border-radius: 19px; */
  padding: 30px;
  /* width: 1200px;
  margin: 30px auto;
  padding: 40px;
  box-shadow: 0px 6px 10px 0px rgba(204, 204, 204, 0.18);
  border-radius: 30px; */
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
}
.startBoxCenter {
  width: 800px;
  margin: auto;
}
.addUser-div {
  /* background: linear-gradient(180deg, #FBF0EA, #FFFFFF 20%); */
  border-radius: 40px;
  padding: 0px 10px;
  width: 500px;
  margin: auto;
  padding-bottom: 70px;
}

/* .startBox .addUser-div .addUser-box {
  background: #fff;
  width: 90%;
  margin: 0 auto;
  height: 100%;
  border-radius: 40px;
} */

.addUser-div .top-tip {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #F15C1A;
  margin-bottom: 20px;
  text-align: center;
}

.addUser-div .center-form {
  width: 100%;
}

.addUser-div .center-form /deep/ .el-form {
  width: 100%;
  margin: 0 auto;
}

.addUser-div .center-form /deep/ .el-form-item__label {
  /* color: #01c2ac; */
  font-weight: 400;
  font-size: 15px;
}

.addUser-div .center-form .age-radio /deep/ .el-radio {
  line-height: 40px;
  color: #cf7f31;
}
.addUser-div .center-form /deep/ .el-radio .el-radio__input.is-checked .el-radio__inner {
  border-color: #F15C1A;
    background: #F15C1A;
}
.addUser-div .center-form /deep/ .el-radio__input.is-checked+.el-radio__label  {
  color: #F15C1A;
}

.addUser-div .center-form .age-radio {
  width: 80%;
}
.addUser-div .btn,
.selectUser-div .btn {
  width: 160px;
  height: 50px;
  background: linear-gradient(90deg, #03cdb4, #00a28e);
  box-shadow: 0px 8px 15px 0px rgba(1, 179, 157, 0.21);
  border-radius: 25px;
}
.addUser-div .btn1,
.selectUser-div .btn1 {
  width: 160px;
  height: 50px;
  background: #ffffff;
  /* box-shadow: 0px 8px 15px 0px rgba(1, 179, 157, 0.21); */
  border-radius: 25px;
}
.btn1 .text {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}

.btn .text {
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
}
.zsureBtn {
  /* margin-right: 20px;
  margin-top: 20px; */
  flex-shrink: 0; /* 禁止压缩高度 */
  position: absolute;
  bottom: -60px;
  left: 0;
  width: 740px;
  height: 80px;
  padding: 0 30px;
  box-shadow: 0px 1px 0px 0px #E6E6E6;
  border-radius: 0px 0px 30px 30px;
  border-top: 1px solid #E6E6E6;
  background: #ffffff;
}

.addUser-div .w-18 {
  width: 90%;
  background: #F4F6F7;
  border-radius: 4px;
}

.selectUser-div {
  background: #fff;
  max-height:  420px;
  min-height:  420px;
  margin: 0 auto;
  border-radius: 30px;
  padding: 20px;
  overflow-y:auto;
}
.selectUser-div1 {
  background: #fff;
  border-radius: 30px;

}
.selectUser-box {
  /* position: relative; */
  max-height:  550px;
  min-height:  550px;
  margin: 0 auto;
  border-radius: 30px;
  padding: 20px;
  overflow-y:auto;
  margin-bottom: 60px;
}
.searchInput ::v-deep() .el-input__inner {
  border-radius: 20px;
  /* height: 50px;
  line-height: 50px; */
  background: #F4F6F7;
  border: none;
}


.w-18 ::v-deep .el-input__inner {
  background-color: #F4F6F7;
  border: none;
}
.center-form ::v-deep .el-form-item__content .el-form-item__error {
  color: #F15C1A;
}

.selectUser-div .selectUser-box,
.test-div .test-box {
  /* width: 90%; */
}
.selectUser-div .userList-div,
.test-div .testList-div {
  width: 100%;
}
.userList-div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.selectUser-div .active {
  border: 1px solid #1B7DB3 !important;
}

.selectUser-div .item-div:hover {
  border: 1px solid #1B7DB3 !important;
}
/* .selectUser-div .item-div1:hover {
  border: 1px solid #1B7DB3 !important;
} */
.selectUser-div .item-div {
  width: 45%;
  /* margin-right: 2%; */
  margin-bottom: 12px;
  background: #F1F6F9;
  border-radius: 10px;
  cursor: pointer;
  align-items: flex-start !important;
  padding: 17px 16px;
  position: relative;
} 
.item-div1 {
  /* width: 43%; */
  /* height: 140px; */
  /* margin-right: 2%; */
  margin-bottom: 20px;
  background: #FFF9F0;
  border-radius: 30px;
  cursor: pointer;
  padding: 20px 30px;
  /* position: relative; */
}
/* .selectUser-div .item-div1:nth-child(3n) {
  margin-right: 0;
} */
/* .selectUser-div .item-div:nth-child(3n) {
  margin-right: 0;
} */

.selectUser-div .userName {
  width: 100%;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: bold;
}

.selectUser-div .item-div .addBtn {
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #009583;
}

.selectUser-div .userInfo {
  font-size: 16px;
  color: #333333;
}

.selectUser-div .topDel-div {
  position: absolute;
  top: 10px;
  right: 0px;
  font-size: 12px;
  color: #333333;
  cursor: pointer;
  background: #D6E8F2;
  border-radius: 12px 0px 0px 12px;
  padding: 5px 10px;
  padding-left: 15px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar-thumb {
  background: #c2c2c2;
  border-radius: 3px;
}
.startBoxleft {
  position: relative;
  width: 800px;
  min-height: 550px;
  max-height: 550px;
  background: #ffffff;
  border-radius: 30px;
  padding: 30px 20px;
  margin: auto;
  overflow-y: auto;
}
.startBoxleftTop {
  height: 500px;
  overflow: hidden;
  overflow-y: auto;
}
/*滚动条样式*/
.startBoxleftTop::-webkit-scrollbar {
  width: 4px;
}
.startBoxleftTop::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.startBoxleftTop::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
}
.startBoxleftBot {
  /* overflow-x:scroll; */
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 15px;
  border-top: 1px solid #e6e6e6;
  position: relative;
}
.startBoxleftBotn {
  margin-top: 12px;
  text-align: right;
  margin-right: 30px;
}
.startBoxright {
  margin-left: 5%;
  width: 30%;
  height: 720px;
  padding: 30px;
  background: #ffffff;
  border-radius: 20px;
  position: relative;
}
.surebtn {
  background: linear-gradient(180deg, #ffb163, #ee9e51);
  font-size: 16px;
  color: #ffffff;
  padding: 17rpx 0;
  width: 100%;
  text-align: center;
}
.wrapDiv {
  width: calc((100% - 3 * 13px) / 4); /* 4个标签 + 3条间隙均分 */
  /* margin-top: 10px; */
}
.goodTagCheck {
  text-align: center;
  background: #FFF9F2;
  border-radius: 4px;
  font-size: 18px;
  color: #E07712;
  cursor: pointer;
  border: 1px solid #FFB066;
  /* width: 180px; */
  width: 100%;
  text-align: center;
  height: 44px;
  line-height: 44px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* margin-right: 13px; */
   padding: 0 10px;
    box-sizing: border-box;   /* 关键 */
   /* width: 25%; */
}
.goodTag {
  font-size: 18px;
  background: #F1F1F1;
  color: #333333;
  border-radius: 4px;
  cursor: pointer;
  /* width: 180px; */
   width: 100%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
   /* margin-right: 13px; */
   padding: 0 10px;
   box-sizing: border-box;   /* 关键 */
  /* width: 25%; */
}
/* 症状 */
.textdetail {
  padding: 15px;
  /* background-color: #f2f2f2; */
  border-radius: 12px;
  max-height: 400px;
  min-height: 200px;
  overflow-y: auto;
}
.viptable {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  overflow-x: auto;
}
.viptableY {
  width: 100%;
  height: 150px;
  overflow: hidden;
  overflow-y: auto;
}
.endbox {
  margin-top: -50px;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 6px 0px 0px #f3d6bc;
  border-radius: 10px;
  border: 1px solid #f3d6bc;
}
.endboxright {
  margin-top: 15px;
  padding: 10px 15px;
  background: #ffffff;
  box-shadow: 0px 6px 0px 0px #f3d6bc;
  border-radius: 10px;
  border: 1px solid #f3d6bc;
  cursor: pointer;
}
.ring {
  width: 12px;
  height: 12px;
  border: 3px solid #cf7f31;
  box-shadow: 0px 2px 3px 0px rgba(202, 127, 55, 0.3);
  border-radius: 50%;
}
.endbox1 {
  margin-top: 20px;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(214, 214, 214, 0.3);
  border-radius: 10px;
  position: relative;
  border: 1px solid #ffe5cb;
}
.ring1 {
    width: 6px;
  height: 6px;
  background: #333333;
  border-radius: 50%;
  margin-right: 5px;
}
.ring2 {
  width: 6px;
  height: 6px;
  background: #3bc8d9;
  border-radius: 50%;
}
.ring3 {
  width: 6px;
  height: 6px;
  background: #68caa9;
  border-radius: 50%;
}
.boxtag2 {
  position: absolute;
  top: 0;
  right: 0;
  padding: 7px;
  color: #ffffff;
  border-radius: 10px 0px 10px 0px;
  background-color: #3bc8d9;
  font-size: 24rpx;
}
.boxtag3 {
  position: absolute;
  top: 0;
  right: 0;
  padding: 7px;
  color: #ffffff;
  border-radius: 10px 0px 10px 0px;
  background: #68caa9;
  font-size: 12px;
}
.boxtag1 {
  position: absolute;
  top: 0;
  right: 0;
  padding: 7px;
  color: #ffffff;
  border-radius: 10px 0px 10px 0px;
  background-color: #f6a11f;
  font-size: 12px;
}
.flexlr {
  display: flex;
  justify-content: space-between;
}
.resultimg {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-image: url("../../assets/img/zdrugConsult/resultback.png");
}
.rightBottom {
  padding: 10px 25px;
  background: #f0f2f2;
  border-radius: 25px;
  font-size: 13px;
  color: #999999;
  text-align: center;
}
.rightBottomBox {
  border-top: 1px solid #e6e6e6;
  padding: 20px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
}
.radioBox {
  margin: 10px 0;
  font-size: 18px;
}
.imgTag {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  margin-left: 10px;
  border-radius: 8px;
}
.drugBox {
  padding: 10px 25px;
  background: #f5f5f5;
  border-radius: 10px;
  margin: 10px 0;
}

.drugBoxtop {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #333;
  font-weight: bold;
}

.drugBoxtopBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
<style>
.personal-center {
  display: none;
}
</style>
